module.exports = __webpack_public_path__ + "static/media/Email.d49894f0.png";